<template>
  <div class="language-container" @click.stop>
    <span class="language-label">{{ $t('ui.language.Language') }}:</span>
    <v-select
      :items="languageItems"
      :model-value="currentLanguage"
      @update:model-value="select"
      class="language-selector"
      density="compact"
      variant="outlined"
      hide-details
    ></v-select>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'LanguageSelector',
  data() {
    return {
      selected: this.currentLanguage,
    }
  },
  computed: {
    ...mapState({
      currentLanguage: state => state.uiStore.language,
      languages: state => state.uiStore.languages,
    }),
    languageItems() {
      return this.languages.map((key) => ({
        value: key.toLowerCase(),
        title: this.$t(`ui.language.${key}`),
      }))
    },
  },
  methods: {
    ...mapMutations({
      SET_LANGUAGE: 'uiStore/SET_LANGUAGE'
    }),
    select(language) {
      this.SET_LANGUAGE(language)
      this.$nextTick(() => {
         setTimeout(() => {
           window.location.reload(true)
        }, 100)
      })
    }
  }
}

</script>

<style scoped>
  .language-container {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .language-label {
    font-size: 1rem;
  }
  .language-selector {
    max-width: 200px;
  }
</style>